import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is entirely cookie-based (httpOnly `owner_token` for admin, `session`
// for customers) — set by the backend on login and sent automatically by the
// browser on every request because of `withCredentials`. No token is ever
// stored in localStorage, closing the XSS attack surface.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function productImage(p) {
  if (p.image_data) return `data:image/png;base64,${p.image_data}`;
  return p.image_url || "https://images.unsplash.com/photo-1555432384-3b2fa7b650c9?w=900";
}
